import { axiosApiInstance } from '@/utils/axios';
import config from '../config';
import { processLine } from '../utils/measure';

class MeasurementController {
  static async getMeasurement(id, imageId, line) {
    const params = {
      id,
      image_id: imageId,
      line: processLine(line),
    };
    try {
      const response = await axiosApiInstance.post(`${config.apiPath}/v1/images/${imageId}/measure/lines`, params);
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default MeasurementController;
